import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { extractError, getCodeFromError } from "@app/lib";
import { Alert } from "antd";
import { useTranslation } from ".";
export const ErrorAlert = ({ banner = false, error, message, setError, ...rest }) => {
    const [mounted, setMounted] = useState(false);
    const { t } = useTranslation();
    const code = getCodeFromError(error);
    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);
    const alertInner = (_jsx(Alert, { ...rest, banner: banner, closable: banner, description: _jsxs("span", { style: {
                wordBreak: "break-word",
                border: "1px solib black",
                display: "block",
            }, children: [extractError(error).message, " ", code && (_jsxs("span", { children: ["(", t("error:errorCode"), ": ", _jsxs("code", { children: ["ERR_", code] }), ")"] }))] }), message: message, type: "error", onClose: () => setError?.(null) }));
    const alertContent = banner ? (_jsx("div", { style: {
            position: "fixed",
            top: "16px",
            left: "50%",
            width: "100%",
            maxWidth: "600px",
            transform: "translate(-50%, 0)",
            zIndex: 999,
        }, children: alertInner })) : (alertInner);
    const alertPortal = mounted
        ? createPortal(alertContent, document?.querySelector("#alert"))
        : null;
    return banner ? alertPortal : alertContent;
};
//# sourceMappingURL=ErrorAlert.js.map